import { Component, OnInit,Inject,Output, EventEmitter ,ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';

@Component({
  selector: 'app-edit-ecowas-business-config-table',
  templateUrl: './edit-ecowas-business-config-table.component.html',
  styleUrls: ['./edit-ecowas-business-config-table.component.scss']
})
export class EditEcowasBusinessConfigTableComponent implements OnInit {

  @Output() refreshTableData = new EventEmitter();
  updateBusinessConfigForm :FormGroup
 
  itemData:any;
  businessConfigData:any;
  showDialog:boolean=false;
  
  constructor(public dialogRef: MatDialogRef<EditEcowasBusinessConfigTableComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private spinnerService: Ng4LoadingSpinnerService,
    private formBuilder:FormBuilder , private endpointsService: EndpointsService, private backendApiService: BackendApiService,) { }

  ngOnInit(): void {
    this.spinnerService.show();
   
    this.itemData=this.data.rowData
    console.log('rowData',this.data.rowData)
    console.log("rowdataaa",this.itemData)
    console.log("aaaaasss",this.itemData.orgId)
    
   
      let apiUrl = this.endpointsService.URL_GET_BUSINESS_CONFIG +
    '&orgId=' + this.itemData.orgId + '&roamOrgId=' + this.itemData.roamOrgId +'&type='+ this.itemData.type ;
 
  this.backendApiService.callToApi(apiUrl).subscribe(response => {
    if(response !=null && response != undefined && response != '[]'){
    this.businessConfigData = response;
    this.showDialog=true;
    console.log("respone", response)
    }
  });
    //console.log('this',this.businessConfigData[0].orgId)
 //   console.log('thisssssss',this.businessConfigData[0]['orgId'])
 this.updateBusinessConfigForm = this.formBuilder.group({
  orgId :[],
  roamOrgId : [],
  ecowas_enabled : [],
message_enabled :[],
charging_enabled :[],
iot_signed :[],
tarrif_sno : [],
tarriff_name : [],
created_date : [],
modified_date : [],
freeRoamValidity :[],
counterValidity :[],
messageInterval : [],
stayHomeInterval : [],
counterStayHomeInterval : [],
ratesApplied : [],
moc :[],
mtc:[],
smsmo:[],
grps:[],
dataOthers:[],
mocNoOfDaysApplied:[],
mtcNoOfDaysApplied:[],
smsmoNoOfDaysApplied:[],
gprsNoOfDaysApplied:[],
dataNoOfDaysApplied:[],
communityId:[],
communityName:[],
whitelist_enabled:[],
vistingCountry:[],
vistingNetwork:[],
primaryType:[],
should_run_primary:[],
should_run_slave:[]
});
    setTimeout(()=>{
      this.updateBusinessConfig();
      this.spinnerService.hide();
    },5000)
   
    
 
   
  }
  // async getApiDataOnload(){
  //   console.log("aaa")
    
  // }
  updateBusinessConfig(){
   console.log("kkkkkkk",this.businessConfigData[0].orgId)
   this.updateBusinessConfigForm = this.formBuilder.group({
    orgId :[this.businessConfigData[0].orgId],
    roamOrgId : [this.businessConfigData[0].roamOrgId],
    ecowas_enabled : [this.businessConfigData[0].ecowas_enabled],
message_enabled :[this.businessConfigData[0].message_enabled],
charging_enabled :[this.businessConfigData[0].charging_enabled],
iot_signed :[this.businessConfigData[0].iot_signed],
tarrif_sno : [this.businessConfigData[0].tarrif_sno],
tarriff_name : [this.businessConfigData[0].tarriff_name],
created_date : [this.businessConfigData[0].created_date],
modified_date : [this.businessConfigData[0].modified_date],
freeRoamValidity :[this.businessConfigData[0].freeRoamValidity],
counterValidity :[this.businessConfigData[0].counterValidity],
messageInterval : [this.businessConfigData[0].messageInterval],
stayHomeInterval : [this.businessConfigData[0].stayHomeInterval],
counterStayHomeInterval : [this.businessConfigData[0].counterStayHomeInterval],
ratesApplied : [this.businessConfigData[0].ratesApplied],
moc :[this.businessConfigData[0].moc],
mtc:[this.businessConfigData[0].mtc],
smsmo:[this.businessConfigData[0].smsmo],
grps:[this.businessConfigData[0].grps],
dataOthers:[this.businessConfigData[0].dataOthers],
mocNoOfDaysApplied:[this.businessConfigData[0].mocNoOfDaysApplied],
mtcNoOfDaysApplied:[this.businessConfigData[0].mtcNoOfDaysApplied],
smsmoNoOfDaysApplied:[this.businessConfigData[0].smsmoNoOfDaysApplied],
gprsNoOfDaysApplied:[this.businessConfigData[0].gprsNoOfDaysApplied],
dataNoOfDaysApplied:[this.businessConfigData[0].dataNoOfDaysApplied],
communityId:[this.businessConfigData[0].communityId],
communityName:[this.businessConfigData[0].communityName],
whitelist_enabled:[this.businessConfigData[0].whitelist_enabled],
vistingCountry:[this.businessConfigData[0].vistingCountry],
vistingNetwork:[this.businessConfigData[0].vistingNetwork],
primaryType:[this.businessConfigData[0].primaryType],
should_run_primary:[this.businessConfigData[0].should_run_primary],
should_run_slave:[this.businessConfigData[0].should_run_slave]
   })
  }
  onClose(){
    this.dialogRef.close('close')
    console.log("fffff")
  }
  onUpdate(){
    this.spinnerService.show();
    this.backendApiService.callToApi(this.endpointsService.URL_UPDATE_BUSINESS_CONFIG +
      '&orgId=' + this.updateBusinessConfigForm.get('orgId').value + '&type='+ this.itemData.type +
      '&roamOrgId=' + this.updateBusinessConfigForm.get('roamOrgId').value+
      '&ecowas_enabled=' + this.updateBusinessConfigForm.get('ecowas_enabled').value+
      '&message_enabled=' + this.updateBusinessConfigForm.get('message_enabled').value+
      '&charging_enabled=' + this.updateBusinessConfigForm.get('charging_enabled').value+
      '&iot_signed=' + this.updateBusinessConfigForm.get('iot_signed').value+
      '&tarrif_sno=' + this.updateBusinessConfigForm.get('tarrif_sno').value+
      '&tarriff_name=' + this.updateBusinessConfigForm.get('tarriff_name').value+
      // '&created_date=' + this.updateBusinessConfigForm.get('created_date').value+
      // '&modified_date=' + this.updateBusinessConfigForm.get('modified_date').value+
      '&freeRoamValidity=' + this.updateBusinessConfigForm.get('freeRoamValidity').value+
      '&counterValidity=' + this.updateBusinessConfigForm.get('counterValidity').value+
      '&messageInterval=' + this.updateBusinessConfigForm.get('messageInterval').value+
      '&stayHomeInterval=' + this.updateBusinessConfigForm.get('stayHomeInterval').value+
      '&counterStayHomeInterval=' + this.updateBusinessConfigForm.get('counterStayHomeInterval').value+
      '&ratesApplied=' + this.updateBusinessConfigForm.get('ratesApplied').value+
      '&moc=' + this.updateBusinessConfigForm.get('moc').value+
      '&mtc=' + this.updateBusinessConfigForm.get('mtc').value+
      '&smsmo=' + this.updateBusinessConfigForm.get('smsmo').value+
      '&grps=' + this.updateBusinessConfigForm.get('grps').value+
      '&dataOthers=' + this.updateBusinessConfigForm.get('dataOthers').value+
      '&mocNoOfDaysApplied=' + this.updateBusinessConfigForm.get('mocNoOfDaysApplied').value+
      '&mtcNoOfDaysApplied=' + this.updateBusinessConfigForm.get('mtcNoOfDaysApplied').value+
      '&smsmoNoOfDaysApplied=' + this.updateBusinessConfigForm.get('smsmoNoOfDaysApplied').value+
      '&gprsNoOfDaysApplied=' + this.updateBusinessConfigForm.get('gprsNoOfDaysApplied').value+
      '&dataNoOfDaysApplied=' + this.updateBusinessConfigForm.get('dataNoOfDaysApplied').value+
      '&communityId=' + this.updateBusinessConfigForm.get('communityId').value+
      '&whitelist_enabled=' + this.updateBusinessConfigForm.get('whitelist_enabled').value+
      '&vistingCountry=' + this.updateBusinessConfigForm.get('vistingCountry').value+
      '&vistingNetwork=' + this.updateBusinessConfigForm.get('vistingNetwork').value+
      '&primaryType=' + this.updateBusinessConfigForm.get('primaryType').value+
      '&should_run_primary=' + this.updateBusinessConfigForm.get('should_run_primary').value+
      '&should_run_slave=' + this.updateBusinessConfigForm.get('should_run_slave').value

      )
      .subscribe(response => {
        console.log("responseeee",response)
        this.spinnerService.hide();
        if (response === null || response === false || response === "{\"status\" : \"false\"}") {
          alert('Not updated');
          this.dialogRef.close(false);

          return;
        } else {
          alert('updated successfully');
          this.dialogRef.close(true);
          this.spinnerService.show();
          this.refreshTableData.emit();
         
        }
  })
}
 
}
